import { isNil } from 'lodash';
import { MBIconV2Name } from '@shared/components/image';
import { API } from '@shared/types/api';
import { isSubformComponent } from '../../utils';
import { FieldOption } from './FieldOption';

export class SubformFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<API.SubformComponent>,
  ) {}

  matchesComponent(component: API.AnyComponent, _reservedIds: Array<string>): boolean {
    return isSubformComponent(component);
  }

  canBeAdded(components: API.AnyComponent[]): boolean {
    return isNil(components.find(c => c.type === 'SUBFORM'));
  }
}
